import type { Route } from "./+types/reviews";
import Page from "../pages/Reviews";
import { pageMeta } from "../lib/meta";
import { legacy } from "../lib/legacy";
import { OG_IMAGE } from "../config/heroArt";
export async function loader() { return { items: await legacy.articles("reviews") }; }
export const meta = () => pageMeta({ title: "Reviews | Gazar", description: "Honest reviews of books, tools, and resources I've actually used.", path: "/reviews", image: OG_IMAGE.reviews });
export default function R({ loaderData }: Route.ComponentProps) { return <Page items={loaderData.items} />; }
